import { formatIs, rankWith } from "@jsonforms/core";

import { RANK } from "./shared.ts";

export const jsonFileDropzoneTester = rankWith(RANK, formatIs("file"));
